import React from 'react';
import { Button, StyleSheet, Text, View } from 'react-native';

import * as Google from 'expo-auth-session/providers/google';
import { makeRedirectUri } from 'expo-auth-session'; // Import correto
import {
  getAuth,
  signInWithCredential,
  GoogleAuthProvider,
} from 'firebase/auth';
import { useData } from '../../../..';

export const NativeComp = () => {
  const fbInit = useData(ct => ct.all.fireInit);
  const auth = getAuth(fbInit);
  const [request, response, promptAsync] = Google.useAuthRequest({
    clientId:
      '707022923688-gcb0cnns331rdes6q8jgm2nohud59qho.apps.googleusercontent.com',
    scopes: ['profile', 'email'],
    redirectUri: makeRedirectUri({
      native: 'com.morfos.goodbike:/oauthredirect', // Para uso em dispositivos nativos
    }),
  });

  React.useEffect(() => {
    if (response?.type === 'success') {
      const { id_token } = response.params;

      // Autenticação com Firebase
      const credential = GoogleAuthProvider.credential(id_token);
      signInWithCredential(auth, credential)
        .then(userCredential => {
          const user = userCredential.user;
          console.warn('Usuário logado:', user);
        })
        .catch(error => {
          console.error('Erro ao autenticar no Firebase:', error);
        });
    }
  }, [response]);

  return (
    <View style={styles.container}>
      <Button title="Login com Google" />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
